
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import AppConfig from "../../config/app-config";

export default defineComponent({
  name: "maintenance-mode",

  data: () => ({
    homePage: AppConfig.WEB_SITE_HOME_PAGE,
  }),

  methods: {
    close(): void {
      window.location.href = AppConfig.WEB_SITE_HOME_PAGE;
    },
  },

  components: { Modal },
});
